import { Component, NgZone, OnInit, TemplateRef} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../../services/constants"
import swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

@Component({
  selector: "app-save-card",
  templateUrl: "./save-card.component.html",
  styleUrls: ["./save-card.component.css"]
})
export class SaveCardComponent implements OnInit {
  allCards: any = [];
  currentPage: number | undefined;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  showErrorCard: boolean = false;
  cardform: FormGroup; 
  token: any; 
  constructor(private modalService: BsModalService, private router: Router,private api: AdminService,private toastrService: ToastrService,private formBuilder: FormBuilder,private _zone: NgZone) { 
    this.cardform = this.formBuilder.group({
      name: ["", [Validators.required, Validators.minLength(2)]],
      CardNumber: ["", [Validators.required, Validators.minLength(18)]],
      CardExpired: ["", [Validators.required, Validators.minLength(4)]],
      CardCCV: ["", [Validators.required, Validators.minLength(3)]],
      isSaved: [""],
    })
  }

  ngOnInit(): void {
    this.getAllCard();
  }

  getAllCard(){
    let params = new HttpParams(); 
    params = params.append("skip", this.pagination.skip.toString());
    params = params.append("limit", this.pagination.limit.toString());
    this.api.getData(apiUrl._getAllCards,params)
    .subscribe(async (res) => {
      this.pagination.totalItems = res.data.count; 
      this.allCards = res.data.listing;
    })
  } 
  // delete card
  
  delete(card){
    let id;
    id = card.id
    let text;
    if(card.isPrimary ==1){
      text = "<p>You can not delete the default payment method. Please set another card as default before deleting this.</p>";
      swal.fire({
        html: text,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonColor: "#EF7E2B",
        cancelButtonColor: "#ffffff",
        confirmButtonText:"Okay",
        cancelButtonText: "No",
        reverseButtons: false,
        width: 500
      }).then((result) => {
        if (result.value) { 
          result.dismiss === swal.DismissReason.cancel
        }
      });
    } else{
      text = "<p>Are you sure you want to Delete this card ?</p>";
      swal.fire({
        html: text,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#EF7E2B",
        cancelButtonColor: "#ffffff",
        confirmButtonText:"Yes",
        cancelButtonText: "No",
        reverseButtons: true,
        width: 500
      }).then((result) => {
        if (result.value) { 
          const data = {
            "id": id,
          }
          this.api.deleteData(apiUrl._deleteCard, data).subscribe(res => {
            this.getAllCard();
          })
        }
      });
    }
    
  }
  // updated card
  setcard(card){ 
    let text = "<p>Are you sure you want to set this card as the Primary card?</p>";
    let isPrimary =1
    if(card.isPrimary == 0){
      isPrimary=1;
      swal.fire({
        html: text,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#EF7E2B",
        cancelButtonColor: "#ffffff",
        confirmButtonText:"Yes",
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        width: 500
    }).then((result) => {
      if (result.value && result.isConfirmed) { 
        const data={
          id:card.id,
          tokenId:card.stripeCardToken,
          isPrimary:isPrimary
        }
          this.api.putData(apiUrl._updateCard,data)
        .subscribe(async (res) => {
          this.getAllCard();
          this.toastrService.success("", "Updated successfully!")
        })
      
    } else{
      result.dismiss === swal.DismissReason.cancel
    }
    });
    } 
    
  }
  //
  
  openModal(template: TemplateRef<any>) { 
    this.cardform.reset();
    this.modalRef = this.modalService.show(
      template,
      Object.assign({},this.config, { class: "modal-md addModal" })
    ); 
  }
  // submit
  createToken() {
    this.api.loader(true)
    var amountCheck = (this.cardform.value.amount > 3 || this.cardform.value.amount == 3)
    if (this.cardform.valid) {
      var month = (this.cardform.value.CardExpired).split("/")[this.cardform.value.CardExpired.split("/").length - 2]
      var year = (this.cardform.value.CardExpired).split("/")[this.cardform.value.CardExpired.split("/").length - 1]
      if (month == undefined) {
        year = this.cardform.value.CardExpired.slice(this.cardform.value.CardExpired.length - 2);
        month = this.cardform.value.CardExpired.slice(0, -2)
      }
      var cardNumber=this.cardform.value.CardNumber.replace(/\s/g, "");
      (<any>window).Stripe.card.createToken({
        number: cardNumber,
        cvc: this.cardform.value.CardCCV, 
        exp_month: month,
        exp_year: year,
        name: this.cardform.value.name,
      }, (status: number, response: any) => {
        this._zone.run(() => {
          console.log(status, response);
          if (status === 200) {
            this.token = response.id;
            this.onCardSubmit();
          } else {
            alert(response.error.message)
            this.api.loader(false)
          }
        }
        )
      }) 
    } else {
      this.showErrorCard = true;
      setTimeout(() => {
        this.showErrorCard = false;
      }, 3000);
      this.api.loader(false)
    }
  }

  keyUPvalue(event) {
    const input = event.target as HTMLInputElement;
    const trimmed = input.value.replace(/\s+/g, "").slice(0, input.value.indexOf("/") == -1 ? 4 : 5);
    if (trimmed.length > 3) {
      this.cardform.value.CardMonth = (input.value = `${trimmed.slice(0, 2)}/${trimmed.slice(trimmed.indexOf("/") == -1 ? 2 : 3)}`);
    }
  }
  keyUPvalue1(event) {
    const self = this;
    console.log(event.target.value.length)
    let chIbn = event.target.value.split(" ").join("");
    if (chIbn.length > 0) {
      chIbn = chIbn.match(new RegExp(".{1,4}", "g")).join(" ");
    }
    this.cardform.patchValue({
      CardNumber:chIbn
    })
  }
  
  onCardSubmit(){  
    const data={
      tokenId:this.token,
      isPrimary:1,
      isSaved:1,
      // isSaved:this.cardform.value.isSaved == true ? 1 : 0,
    } 
    this.api.postData(apiUrl._addCard,data)
      .subscribe(async (res) => {
        setTimeout(() => {
          this.getAllCard();
          this.modalRef?.hide();
          this.cardform.reset();
        }, 1000);
        this.api.loader(false)
      })
  }
}
